if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"sbg_evo","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(777|805|897|91)|3(277|423|631)|4([12]33|217|547|89)|5(2(61|7|99)|051|443|599|677|735|903)|6(255|747|909)|7(81(|5)|191|20|389|485|539|582|971)|8(019|203|315|395|707)|1[27]29|9291|9553)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}